import React, {useEffect, useState} from 'react'
import Loader from "../../../components/Loader";
import HttpRequest from "../../../HttpRequest";

const Reports = (props) => {
    const
        [reports, setReports] = useState([]),

        [isLoadCompleted, setLoadCompleted] = useState(reports.length > 0)
    ;
    let isLoadInProgress = false;

    const loadReports = async (event) => {
        if(!isLoadInProgress){
            try {
                isLoadInProgress = true;
                const response = await (new HttpRequest()).request(props.url, "GET").then(function (response){
                    let data = {server: response, isLoadCompleted: true};
                    if(response.code === 200){
                        data.reports = response.data.reports;
                    }
                    isLoadInProgress = false;
                    return {
                        server: response,
                        data: data,
                    };
                }).catch(function (error){console.log(error)});

                if(response && response.data.reports){
                    setLoadCompleted(true);
                    setReports(response.data.reports);
                }
            }
            catch (e) {console.log(e)}
        }

    }

    useEffect(() => {
        loadReports();
    }, []);


    let element;
    if(!isLoadCompleted && reports.length <= 0){
        element = <Loader />;
    }
    else{
        const
            rows = reports.map((report, index) => {
                return <tr key={"row-" + index}>
                    <td><a href={report.fileLink} target="_blank">{report.fileName}</a></td>
                    <td>{report.fileType}</td>
                    <td>{report.fileDescription}</td>
                </tr>
            }),
            table = <table className="table table-bordered table-striped table-hover table-responsive">
                <thead>
                <tr>
                    <th>Nom du fichier</th>
                    <th>Type</th>
                    <th>Description</th>
                </tr>
                </thead>
                <tbody>
                {rows ? rows : <tr><td colSpan="3">Vide</td></tr>}
                </tbody>
            </table>
        ;

        element = <div className="row">
            <div className="col-md-12">
                {table}
            </div>
        </div>
    }

    return element;
}

export default Reports;